<template>
  <main class="view">
    <div class="information">
      <p>Page not found</p>
      <p><router-link to="/">Work</router-link></p>
    </div>
  </main>
</template>

<script setup>
</script>
